module.exports = __webpack_public_path__ + "static/media/content3.54e51ab3.svg";